import React from 'react';
import Button from 'components/forms/Button';
import { statsService } from 'utils/api';
import { downloadExcel } from 'utils/fileDownload';
import { useSelector } from 'react-redux';
import session from 'containers/App/session';
import messages from './messages';
import { FormattedMessage } from 'react-intl';

const OtaInsightExportModule = ({ start, end, propertyId }) => {
    const token = useSelector(session.selectors.selectUserToken);

    const exportExcel = async () => {
        const excelFileResponse = await statsService({
            token,
            propertyId,
        }).getOTAInsightsByDayExport({
            start,
            end,
        });
        const contentDisposition = excelFileResponse.headers['content-disposition'];
        const match = contentDisposition.match(/filename\s*=\s*"(.+)"/i);
        const filename = match[1];

        downloadExcel(excelFileResponse.data, filename);
    };

    return (
        <>
            <Button type="primary" onClick={exportExcel}>
                <FormattedMessage {...messages.exportButton} />
            </Button>
        </>
    );
};

export default OtaInsightExportModule;
